import { defineMessages } from 'react-intl';

const _default_1: {
	hubLogo: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	login: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	hubLogo: {
		id: 'company-hub.hub-app-shell.navbar.hub.logo',
		defaultMessage: 'Support home',
		description:
			'The accessible label for the Hub logo link in the navigation bar, which navigates to the support home page when clicked.',
	},
	login: {
		id: 'company-hub.hub-app-shell.navbar.hub.log-in',
		defaultMessage: 'Log in',
		description:
			'The text is shown on a button in the navigation bar that allows unauthenticated users to sign in to the help center.',
	},
});
export default _default_1;
